define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.concat;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/concat.js
// module id = 1860
// module chunks = 37